"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6119],{

/***/ 66119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(35944);
/* harmony import */ var _emotion_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97133);
/* harmony import */ var _prezzee_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34906);
/* harmony import */ var _prezzee_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_prezzee_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _prezzee_ribbon_ui_lib_components_Modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15115);
/* harmony import */ var _prezzee_ribbon_ui_lib_components_Typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43543);
/* harmony import */ var _prezzee_ribbon_ui_lib_theme_foundations_colors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85171);
/* harmony import */ var _prezzee_ribbon_ui_lib_hooks_useDisclosure__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18500);
/* harmony import */ var _RetailerListModal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99725);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67294);
/* harmony import */ var contexts_ProductPageContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(16029);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(20949);
/* harmony import */ var _prezzee_ribbon_ui_lib_components_Box__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(18636);












var style = {
    title: /*#__PURE__*/ (0,_emotion_css__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)("font-weight:600;"),
    accordionPanel: /*#__PURE__*/ (0,_emotion_css__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)("white-space:pre-wrap;font-weight:300;padding-bottom:20px;a{color:", _prezzee_ribbon_ui_lib_theme_foundations_colors__WEBPACK_IMPORTED_MODULE_4__["default"].blue[500], ";text-decoration:underline;&:hover{color:", _prezzee_ribbon_ui_lib_theme_foundations_colors__WEBPACK_IMPORTED_MODULE_4__["default"].blue[600], ";}}"),
    tncModal: /*#__PURE__*/ (0,_emotion_css__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)("white-space:pre-wrap;a{color:", _prezzee_ribbon_ui_lib_theme_foundations_colors__WEBPACK_IMPORTED_MODULE_4__["default"].blue[500], ";text-decoration:underline;&:hover{color:", _prezzee_ribbon_ui_lib_theme_foundations_colors__WEBPACK_IMPORTED_MODULE_4__["default"].blue[600], ";}}")
};
var ZagCardDetails = function() {
    var participatingBrandsModal = (0,_prezzee_ribbon_ui_lib_hooks_useDisclosure__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    var retailerTncModal = (0,_prezzee_ribbon_ui_lib_hooks_useDisclosure__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    var sku = (0,contexts_ProductPageContext__WEBPACK_IMPORTED_MODULE_8__/* .useProduct */ .i)().sku;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(react__WEBPACK_IMPORTED_MODULE_7__.Fragment, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_prezzee_components__WEBPACK_IMPORTED_MODULE_1__.Accordion, {
                allowZeroExpanded: true,
                variant: "secondary",
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_prezzee_components__WEBPACK_IMPORTED_MODULE_1__.AccordionItem, {
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_prezzee_components__WEBPACK_IMPORTED_MODULE_1__.AccordionItemHeading, {
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_prezzee_components__WEBPACK_IMPORTED_MODULE_1__.AccordionItemButton, {
                                children: "Read the full details"
                            })
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_prezzee_components__WEBPACK_IMPORTED_MODULE_1__.AccordionItemPanel, {
                            className: style.accordionPanel,
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_prezzee_ribbon_ui_lib_components_Typography__WEBPACK_IMPORTED_MODULE_3__["default"], {
                                    variant: "body1",
                                    as: "h4",
                                    color: "gray.800",
                                    mb: "2",
                                    children: [
                                        sku.name,
                                        " eGift Card"
                                    ]
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_markdown__WEBPACK_IMPORTED_MODULE_11__/* .Markdown */ .UG, {
                                    children: sku.description
                                })
                            ]
                        })
                    ]
                })
            }),
            participatingBrandsModal.isOpen && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_RetailerListModal__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                title: "Available brands",
                onClose: participatingBrandsModal.onClose,
                uid: sku.uid,
                showDefaultStore: true
            }),
            retailerTncModal.isOpen && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_prezzee_ribbon_ui_lib_components_Modal__WEBPACK_IMPORTED_MODULE_2__/* .Modal */ .u_, {
                isOpen: true,
                onClose: retailerTncModal.onClose,
                isCentered: true,
                scrollBehavior: "inside",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_prezzee_ribbon_ui_lib_components_Modal__WEBPACK_IMPORTED_MODULE_2__/* .ModalOverlay */ .ZA, {}),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_prezzee_ribbon_ui_lib_components_Modal__WEBPACK_IMPORTED_MODULE_2__/* .ModalContent */ .hz, {
                        width: "100%",
                        maxW: "600",
                        maxH: "400",
                        "aria-labelledby": "retailer-tnc-dialog-title",
                        "aria-describedby": "retailer-tnc-dialog-description",
                        margin: "20px",
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_prezzee_ribbon_ui_lib_components_Modal__WEBPACK_IMPORTED_MODULE_2__/* .ModalHeader */ .xB, {
                                children: [
                                    sku.name,
                                    " eGift Card Terms & Conditions"
                                ]
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_prezzee_ribbon_ui_lib_components_Modal__WEBPACK_IMPORTED_MODULE_2__/* .ModalCloseButton */ .ol, {}),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_prezzee_ribbon_ui_lib_components_Modal__WEBPACK_IMPORTED_MODULE_2__/* .ModalBody */ .fe, {
                                pb: "6",
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_prezzee_ribbon_ui_lib_components_Box__WEBPACK_IMPORTED_MODULE_9__["default"], {
                                    className: style.tncModal,
                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_markdown__WEBPACK_IMPORTED_MODULE_11__/* .Markdown */ .UG, {
                                        children: sku.merchant.terms
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ZagCardDetails);


/***/ })

}]);